<script>
import NavBar from '@components/NavBar/nav-bar'
import Footer from '@components/Footer/Footer'
import widgetMethod from '@src/mixins/widgetMethod.js'

export default {
  components: { NavBar, Footer },
  mounted() {
    if (this.$route.meta.authRequired) {
      this.displayWidget()
    }
  },
  methods: {
    ...widgetMethod,
  },
}
</script>

<template>
  <div :class="[$style.container, $style.paddingbottombig]" class="mainBox">
    <div>
      <NavBar />
      <slot />
    </div>
    <Footer />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.paddingbottombig {
  padding-bottom: 4rem;
}
</style>

<style scoped>
.mainBox {
  position: relative;
  min-height: 100vh;
  overflow: visible;
}
</style>
